import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DownloadedReport } from '@huge-monorepo/hip/domain';
import { TableAction } from '@huge-monorepo/hip/domain';
import { TableHeader } from '@huge-monorepo/hip/domain';
import { GenericService } from '@huge-monorepo/hip/services';
import { Endpoints } from '@huge-monorepo/hip/services';
import { TableComponent, TableRefresh } from '../table/table.component';

@Component({
  selector: 'app-profile-files-modal',
  templateUrl: './profile-files-modal.component.html',
  styleUrls: ['./profile-files-modal.component.scss'],
})
export class ProfileFilesModalComponent implements OnInit {
  @ViewChild('profileFilesTable', { static: false }) public profileFilesTable: TableComponent;

  URL: string = '/reports/users/0/downloaded/';
  tableRefreshConfig: TableRefresh = new TableRefresh(true, false, 0.5, null);

  headers: TableHeader[] = [
    {
      ID: 'ID',
      Index: 0,
      Sort: 'ID',
      Sortable: true,
      Text: '#',
      Type: Number,
      Width: 50,
      HTML: `<span [ngClass]="{'green': element.Status === 'Ready', 'red': element.Status === 'Error', 'space-grey': element.Status === 'Generating'}" class="dot"></span>`,
      HTMLMod: (element) => {
        let c = 'space-grey-dot';
        if (element != null) {
          if (element['Status'] === 'Ready') {
            c = 'green-dot';
          } else if (element['Status'] === 'Error') {
            c = 'red-dot';
          }
        }
        return c;
      },
    },
    {
      ID: 'expiry',
      Index: 1,
      Sort: 'Expiry',
      Sortable: true,
      Text: 'Expires',
      Type: Date,
    },
    {
      ID: 'Title',
      Index: 2,
      Sort: 'Title',
      Sortable: true,
      Text: 'Name',
      Type: String,
    },
    {
      ID: 'Message',
      Index: 3,
      Sort: 'Message',
      Sortable: false,
      Text: 'Message',
      Type: String,
      Width: 300,
    },
    {
      ID: 'Downloadable',
      Index: 4,
      Sort: 'Downloadable',
      Sortable: true,
      Text: 'Downloadable',
      Type: Boolean,
      Width: 75,
    },
    {
      ID: 'Error',
      Index: 4,
      Sort: 'Error',
      Sortable: true,
      Text: 'Error',
      Type: Boolean,
      Width: 50,
    },
    {
      ID: 'Status',
      Index: 5,
      Sort: 'Status',
      Sortable: true,
      Text: 'Status',
      Type: String,
      Width: 80,
    },
  ];

  Actions: TableAction[] = [
    {
      Icon: 'cloud_download',
      Text: 'Download',
      Caller: (report: DownloadedReport) => {
        if (report == null) return;
        let url = this.endpoints.DOWNLOAD_DOWNLOADED_REPORT(report.ID);
        this.db.download(url, null, 'get').subscribe((temp) => {
          this.db.createToast('Download Starting', 'Your report will start downloading momentarily.');
        });
      },
      Validator: (report: DownloadedReport) => {
        if (report.Downloadable === true) {
          return true;
        }
        return false;
      },
    },
  ];

  constructor(private db: GenericService, public dialogRef: MatDialogRef<ProfileFilesModalComponent>, @Inject(MAT_DIALOG_DATA) public data: Object, private endpoints: Endpoints) {
    // console.log(data);
  }

  ngOnInit() {}

  closeDialog(val: boolean) {
    this.dialogRef.close(val);
  }
}
